module.exports = __webpack_public_path__ + "img/6_163.88c90804.png";